import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthJWTService } from './modules/auth/auth.jwt.service';
import { AppFormsNavigatorService } from './_services/app-forms-navigator-service';
import { TokenService } from './_services/token-service';
@Component({
  template: "",
  standalone: true
})
export class AppFormsNavigator implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: AppFormsNavigatorService,
    private tokenService: TokenService,
    private authJWSService: AuthJWTService  ) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(param => {
      if (param == null) {
        this.router.navigate(["error"]);
        return;
      }

      this.service.validateToken(param.token).subscribe(data => {
        if (data == null) {
          this.router.navigate(["error"]);
          return;
        }
        this.tokenService.sendtempToken(data);
        this.router.navigate(["auth/authentication"]);
      });
    });
  }
}
